import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { Property } from '@propertypal/shared/src/types/property';
import { isWhite } from '@propertypal/shared/src/utils/colour';
import getSellingAgent, { getAgentColours } from '@propertypal/shared/src/utils/property/getSellingAgent';
import React, { FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { CloseButton, Container, Logo } from './PropertyAgentBar.style';

interface Props {
  property: Property;
  hideOnMobile?: boolean;
  onClose?: () => void;
}

const PropertyAgentBar: FunctionComponent<Props> = (props) => {
  const sellingAgent = getSellingAgent(props.property);
  const { pdpBrandingBgColour } = getAgentColours(props.property.enhancedBranding, sellingAgent);
  const theme = useTheme();

  if (!props.property.enhancedBranding) {
    return null;
  }

  return (
    <Container color={pdpBrandingBgColour} hideOnMobile={props.hideOnMobile} className="hide-print">
      <Logo src={sellingAgent?.logo?.premier} />

      {props.onClose && (
        <CloseButton type="button" onClick={props.onClose}>
          <FontAwesomeIcon
            icon={faTimes}
            color={isWhite(pdpBrandingBgColour) ? theme.textDark : theme.white}
            size={32}
          />
        </CloseButton>
      )}
    </Container>
  );
};

export default PropertyAgentBar;
